import React from 'react';
import { TopicTypes } from 'store/modules/course_store/types';
import SetaDown from 'assets/images/seta_down.svg';
import LessonItem from 'components/atoms/lesson_item';

interface ListTopicsProps {
  topic: TopicTypes;
  index: number;
  last_lesson: number;
  courseSubscriber: boolean;
  scrollToVideo: () => void;
}

const ListTopics = (props: ListTopicsProps) => {
  const { topic, index, last_lesson, courseSubscriber, scrollToVideo } = props;

  const hasFreeLesson = topic?.lessons?.some((lesson) => lesson.free === true);
  return (
    <div className="modules-list border-bottom py-3 pl-3 pr-1">
      <div className="row">
        {!courseSubscriber && (
          <div className="col-1">
            <i className="material-icons" style={{ color: hasFreeLesson ? '#28A745' : '#646464' }}>
              {hasFreeLesson ? 'lock_open' : 'lock'}
            </i>
          </div>
        )}
        <div className={`${courseSubscriber ? 'col-10' : 'col-9'}`}>
          <span className="modulo">Módulo {index + 1}</span>
        </div>
        <div className="col-2">
          <span className="modulo-count">
            {topic?.completed_lessons_count || 0} / {topic?.lessons?.length}
          </span>
        </div>
      </div>
      <div className="row d-print-none">
        <div className="col-md-12">
          <div className="row">
            <div className="col-md-12">
              <a
                className={`title d-flex justify-content-between ${
                  last_lesson === Number(topic?.id) ? '' : 'collapsed'
                }`}
                data-toggle="collapse"
                href={`#collapse${topic?.id}`}
                aria-expanded="true"
                aria-controls="collapseExample"
              >
                {topic?.name}
                <img className="px-2 nav-arrow" alt="Listar modulo" src={SetaDown} />
              </a>
            </div>
          </div>
          <div
            className={`collapse ${last_lesson === Number(topic?.id) ? 'show' : ''}`}
            id={`collapse${topic?.id}`}
          >
            <ul className="list-group list-group-flush">
              {topic?.lessons?.map((lesson) => (
                <LessonItem key={lesson?.id} lesson={lesson} scrollToVideo={scrollToVideo} />
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListTopics;
